import hljs from 'highlight.js';
import { huff } from 'highlightjs-huff';
import cairo from 'prismjs-cairo';
import { CSSProperties, FC } from 'react';
import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import javascript from 'react-syntax-highlighter/dist/cjs/languages/prism/javascript';
import json from 'react-syntax-highlighter/dist/cjs/languages/prism/json';
import markdown from 'react-syntax-highlighter/dist/cjs/languages/prism/markdown';
import solidity from 'react-syntax-highlighter/dist/cjs/languages/prism/solidity';
import { IDisplayCode } from './DisplayCode.type';
SyntaxHighlighter.registerLanguage('javascript', javascript);
SyntaxHighlighter.registerLanguage('solidity', solidity);
SyntaxHighlighter.registerLanguage('json', json);
SyntaxHighlighter.registerLanguage('markdown', markdown);
SyntaxHighlighter.registerLanguage('cairo', cairo);
hljs.registerLanguage('huff', huff);

import { atomDark } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import CopyOnClick from 'src/components/common/CopyOnClick';
import useResponsive from 'src/hooks/contexts/useResponsive';

const syntaxStyle: {
	default: CSSProperties;
	md: CSSProperties;
} = {
	default: { display: 'inline-table', width: '95%', lineBreak: 'anywhere' },
	md: { display: 'inline-table', width: '95%', lineBreak: 'anywhere' }
};

const lineStyle = { style: { fontSize: '0.9rem' } };

const DisplayCode: FC<IDisplayCode> = ({ code, language }) => {
	const { isSmallerThanMd } = useResponsive();
	if (!code) {
		return <></>;
	}

	return (
		<CopyOnClick visibleOnHover value={code as string}>
			<SyntaxHighlighter
				language={language}
				style={atomDark}
				customStyle={isSmallerThanMd ? syntaxStyle.md : syntaxStyle.default}
				wrapLongLines
				lineProps={lineStyle}
				PreTag='div'
				className='code'
			>
				{code}
			</SyntaxHighlighter>
		</CopyOnClick>
	);
};

export { DisplayCode };
